/* istanbul ignore next */
/** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */
const ColumnGroup = _ => null;
export default ColumnGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/table/ColumnGroup.js
// module id = 3649
// module chunks = 0